import { render, staticRenderFns } from "./MailSuccess.vue?vue&type=template&id=fddea820&scoped=true"
import script from "./MailSuccess.vue?vue&type=script&lang=js"
export * from "./MailSuccess.vue?vue&type=script&lang=js"
import style0 from "./MailSuccess.vue?vue&type=style&index=0&id=fddea820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddea820",
  null
  
)

export default component.exports